import axios from "axios"
import { defaultHeader } from "../constants/defaultItems"
import { toast } from "@/components/ui/use-toast";

export const SubmitContactForm = (postData, callback) => (dispatch) => {
    axios.post(`/api/ContactUs/Create`, postData, defaultHeader).then((resp) => {
        if (resp.data.IsSuccess) {
            toast({
                variant: "success",
                title: "Success",
                description: resp.data.Message,
            });
            if (callback) callback();
        }
        console.log(resp);
    })
}